<template>
  <div class="c-no-result">
    <div class="no-result">
      <img
        :src="
          generateStaticImageUrl('/cdn/Booking.ir/UI/Assets/Img/no-result.png')
        "
        alt="no-result"
        class="no-result__img"
      />

      <p class="no-result__title">موردی یافت نشد</p>

      <button class="btn btn--secondary w-100" title="جستجوی مجدد" @click="reLoad">
        جستجوی مجدد
      </button>
    </div>
  </div>
</template>

<script>
import { generateStaticImageUrl } from "@/helpers/tools";
export default {
  methods: {
    generateStaticImageUrl,
    reLoad() {
      document.location.reload(true);
    },
  },
};
</script>
<style scoped lang="scss">
@import "../style/modules/noResult.scss";
</style>
